module.exports = __webpack_public_path__ + "static/media/att.AjWOEWDAmeyk4a4VqQWDuCGu5YNB9Q8mdSks5lDSnn8.b0005d75.jpg";